import styled from "styled-components";

export const PaymentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh; /* ✅ Ensures full screen coverage */
    height: 100%;
    padding: 2rem;
    background-color: #f9f9f9;
    overflow-y: auto; /* ✅ Allows scrolling if content overflows */

    /* ✅ Mobile Support */
    @media (max-width: 768px) {
        padding: 1rem;
    }
`;

export const StatusBox = styled.div`
    background: white;
    padding: 2rem;
    border-radius: 12px;
    text-align: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-width: 350px;
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    /* ✅ Mobile Support */
    @media (max-width: 768px) {
        max-width: 300px;
        padding: 1.5rem;
    }
`;

/* ✅ Green Check Circle */
export const SuccessIconContainer = styled.div`
    width: 80px;
    height: 80px;
    background-color: #4CAF50;
    color: white;
    font-size: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 auto 1rem;

    /* ✅ Mobile Support */
    @media (max-width: 768px) {
        width: 70px;
        height: 70px;
        font-size: 2.5rem;
    }
`;

/* ✅ Red Cancel Circle */
export const CancelIconContainer = styled.div`
    width: 80px;
    height: 80px;
    background-color: #E53935;
    color: white;
    font-size: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 auto 1rem;

    /* ✅ Mobile Support */
    @media (max-width: 768px) {
        width: 70px;
        height: 70px;
        font-size: 2.5rem;
    }
`;

export const Title = styled.h2`
    font-size: 1.8rem;
    margin-bottom: 0.5rem;

    /* ✅ Mobile Support */
    @media (max-width: 768px) {
        font-size: 1.5rem;
    }
`;

export const SuccessTitle = styled(Title)`
    color: #4CAF50;
`;

export const CancelTitle = styled(Title)`
    color: #E53935;
`;

export const Message = styled.p`
    font-size: 1rem;
    color: #333;

    /* ✅ Mobile Support */
    @media (max-width: 768px) {
        font-size: 0.9rem;
    }
`;

/* ✅ Success Button */
export const SuccessButton = styled.button`
    background-color: #4CAF50;
    color: white;
    border: none;
    padding: 0.7rem;
    width: 100%;
    border-radius: 6px;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    margin-top: 1rem;

    &:hover {
        background-color: #43A047;
    }

    /* ✅ Mobile Support */
    @media (max-width: 768px) {
        padding: 0.6rem;
        font-size: 0.9rem;
    }
`;